import instance from "services/axiosServices";

/**
 * @function postSolicitacao
 * @param {Object} params - parâmetros.
 * @param {string} params.idEmpreendimento - GUID do empreendimento.
 * @param {Object[]} params.convidadosCyrelaCia - lista de convidados Cyrela Cia.
 * @param {string} params.convidadosCyrelaCia.tipoDocumento - tipo de documento.
 * @param {string} params.convidadosCyrelaCia.nome - nome do convidado.
 * @param {string} params.convidadosCyrelaCia.idUsuarioVisita - GUID do usuário Cyrela Cia.
 * @param {string} params.convidadosCyrelaCia.documento - documento do convidado.
 * @param {boolean} params.convidadosCyrelaCia.corretorParceiro - se é um corretor parceiro.
 * @param {Object[]} params.convidadosCliente - lista de convidados clientes.
 * @param {string} params.convidadosCliente.nome - nome do convidado.
 * @param {Object[]} params.locais - lista de locais.
 * @param {string} params.locais.torre - nome da torre.
 * @param {string} params.locais.idTorre - GUID da torre.
 * @param {string} params.locais.unidade - nome da unidade.
 * @param {Object[]} params.dadosVeiculo - lista de veículos.
 * @param {string} params.dadosVeiculo.veiculo - nome do veículo.
 * @param {string} params.dadosVeiculo.placa - placa do veículo.
 * @param {Date | null} params.dataAgendamento - data de agendamento.
 * @param {string} params.horaInicioAgendamento - hora de início do agendamento.
 * @param {string} params.horaFimAgendamento - hora de fim do agendamento.
 * @returns {Promise<any>} - retorna confirmação da request.
 */
export const postSolicitacao = async (params: {
  idEmpreendimento: string;
  convidadosCyrelaCia: {
    tipoDocumento: number;
    nome: string;
    idUsuarioVisita: string;
    documento: string;
    corretorParceiro: boolean;
  }[];
  convidadosCliente: { nome: string }[];
  locais: { torre: string; idTorre: string; unidade: string }[];
  dadosVeiculo: { veiculo: string; placa: string }[];
  dataAgendamento: Date | null;
  horaInicioAgendamento: string;
  horaFimAgendamento: string;
}) => {
  const url = "locais/admin/solicitacaoVisita/v1";
  const response = await instance.post(url, params);
  return response?.data;
};
